import React, { Component,useEffect,useState } from "react";
import Slider from "react-slick";
import Categories from "../Categories/Categories";
// import "~slick-carousel/slick/slick.css"; 
// import "~slick-carousel/slick/slick-theme.css";
import './slick.min.css'
import './slick-theme.min.css'
import './Slider.css'

import Category from "../Category/Category"
import {buildItemsList} from "../../Data/GeneralFanction"
import {getAll} from "../../Data/Utils"



const MySliser = () => { 

  const [ categoriesState,setCategoriesState]=useState([]);
  
useEffect(()=>{
  const getCtegories = async () => {
      const webUrl=window.srcSiteUrl;//process.env.REACT_APP_APIURL;
      const apiUrl=config.apiUrl;
      const categoriesList=config.lists.categories.name; 
      const selectedProps=config.lists.categories.selectProperties;
      let { data: categoriesAll } = await getAll(`${webUrl}${apiUrl}?listName=${categoriesList}&selectedProps=${selectedProps}`);
      var x=buildItemsList(categoriesAll);
      //switchLang("categories",x);
      setCategoriesState(x) ;
      console.log(categoriesState);
  };
var config = require('../../config.json');
  // if(categories.length>0){
  //   setCategoriesState(categories);    
  // }
  // else{
    getCtegories();
  // }
  
  

},[]);

var settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3.5,
  slidesToScroll:2,
  initialSlide: 0,
  arrows: false
  
  
};

 
   
    return (
      <div className="slider-container">

        <Slider {...settings}>
        {
      categoriesState.map((item,index)=>{
        return <Category key={index} category={item} />
      })
    }
       
        </Slider>
      </div>
    );
  }


export default MySliser
